@import "../../common/_base";

@include box-sizing();

:host {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
}

:host([items-overflow-behavior="add-scroll"]) {
  overflow-x: auto;
}

:host([items-overflow-behavior="multiline"]) {
  display: flex;
  flex-wrap: wrap;
}

:host([items-overflow-behavior="responsive-collapse"]) {
  contain: inline-size;
}

hr {
  display: grid;
  align-self: stretch;
  inline-size: 1px;
  margin: 0;
  background-color: color-mix(in srgb, currentColor 25%, transparent);
  border: unset;
  pointer-events: none;
}

.marker {
  display: grid;
  align-items: center;
  align-self: stretch;

  &--hidden {
    visibility: hidden;
  }
}
